import RequestBuilder from '@/services/api/requestBuilder';

export default {
  getAll() {
    return new RequestBuilder('GET', '/users/me/stats');
  },
};
